module.exports = __webpack_public_path__ + "img/sign.ad5cef4c.svg";